var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorvelios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -5 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "revolver-cylinder-scallop",
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "revolver-bullet",
    r: 1.3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "outline1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 12,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    transform: "rotate(-225)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "outline2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 12,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "rotate(45) "
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "rotate(225)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-10)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: 3,
    x2: 3,
    y2: -3,
    stroke: "#a7a7a7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: -3,
    x2: 3,
    y2: 3,
    stroke: "#2f7500",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    mask: "url(#outline1)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    mask: "url(#outline2)",
    fill: "#2f7500"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorvelios);
export default __webpack_public_path__ + "static/media/norvelios.99b988c51056015358c8e950ed734510.svg";
export { ForwardRef as ReactComponent };